import React from 'react';
import { Tooltip } from '../../pages/Users/components/Tooltip/Tooltip';
import { useTooltip } from '../hooks/useTooltip';

type DeleteIconProps = {
  onClick: () => void;
  disabled?: boolean;
};

const noop = () => {};

export const DeleteIcon: React.FC<DeleteIconProps> = ({
  onClick,
  disabled = false,
}: DeleteIconProps): JSX.Element => {
  const { open, handleToggleTooltip } = useTooltip();
  const color = disabled ? '#cccccc' : '#394577';

  return (
    <div className="table__icon">
      {!disabled ? <Tooltip open={open} text="Delete users" /> : null}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="table__icon__icon"
        onMouseEnter={handleToggleTooltip}
        onMouseLeave={handleToggleTooltip}
        onClick={disabled ? noop : onClick}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 8.75H6C5.44772 8.75 5 8.30228 5 7.75C5 7.19772 5.44772 6.75 6 6.75H18C18.5523 6.75 19 7.19772 19 7.75C19 8.30228 18.5523 8.75 18 8.75H17.5V19.25C17.5 19.8023 17.0523 20.25 16.5 20.25H7.5C6.94772 20.25 6.5 19.8023 6.5 19.25V8.75ZM8.5 8.75V18.25H15.5V8.75H8.5Z"
          fill={color}
        />
        <rect
          x="8.50146"
          y="3.75"
          width="6.4983"
          height="2"
          rx="1"
          fill={color}
        />
        <rect
          x="14.5"
          y="10.8291"
          width="5.34235"
          height="2"
          rx="1"
          transform="rotate(90 14.5 10.8291)"
          fill={color}
        />
        <rect
          x="11.5"
          y="10.8291"
          width="5.34235"
          height="2"
          rx="1"
          transform="rotate(90 11.5 10.8291)"
          fill={color}
        />
      </svg>
    </div>
  );
};
